import ItemsListVue from '@/views/sa/items-list/items-list.vue';

const basePath = '/sa/items-list';
const role = 'sa'; // 角色身份

export const SA_ITEMS_LIST_INDEX = 'sa-items-list-index';

export default {
  path: `${basePath}*`,
  redirect: `${basePath}/index`,
  component: ItemsListVue,
  meta: { requiresAuth: true },
  children: [
    {
      path: `${basePath}/index`,
      name: SA_ITEMS_LIST_INDEX,
      component: () => import(
        /* webpackChunkName: "chatRoom" */
        `@/views/${role}/items-list/index.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    }
  ]
};
